import { FC, useCallback, useMemo } from 'react'
import { Badge, Button, Pagination, Space, Table } from 'antd'
import PageLayout from '../../components/page-layout/page-layout'
import useEndpointQueryParams from '../../hooks/table-pages/use-endpoint-query-parameters'
import { getColumns } from './constants/columns'
import useTablePagination from '../../hooks/table-pages/use-table-pagination'
import { buildDesignerTasksDataSource } from './helpers/build-data-source'
import { getRowKey } from './helpers/row-helpers'
import TableWrapper from '../../components/table-wrapper/table-wrapper'
import useDesignerTasksRefresh from './hooks/use-designer-tasks-refresh'
import HelpDrawer from './components/help-drawer/help-drawer'
import FilterForm from './components/filters-form/filters-forms'
import useFiltersForm from '../../hooks/forms/use-filters-form'
import { deserializeFilters } from './helpers/deserialize-filters'

const DesignerTasksPage: FC = () => {
    const params = useEndpointQueryParams({ deserializeFilters })
    const { form: filterForm, onSearch, onClear } = useFiltersForm()
    const { data, newTasksCount, newStatusCount, handleRefresh } = useDesignerTasksRefresh(params)
    const pagination = useTablePagination(params, data)

    const dataSource = useMemo(
        () => buildDesignerTasksDataSource(data?.data ?? []),
        [data]
    )

    const columns = useMemo(() => getColumns(newStatusCount), [newStatusCount])

    const tableFooter = useCallback(
        () => <Pagination {...pagination} size='small' align='end' />,
        [pagination]
    )

    return (
        <PageLayout
            title={'Задачи дизайнера'}
            beforeUser={
                <Space size={8}>
                    <HelpDrawer />
                    <Badge count={newTasksCount} overflowCount={99}>
                        <Button onClick={handleRefresh}>Обновить</Button>
                    </Badge>
                </Space>
            }
        >
            <div style={{ marginBottom: 12 }}>
                <FilterForm form={filterForm} onSearch={onSearch} onClear={onClear} />
            </div>
            <TableWrapper style={{ flex: 'auto' }} filtersSummaryHeight={0}>
                <Table
                    bordered
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    rowKey={getRowKey}
                    size='small'
                    footer={tableFooter}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default DesignerTasksPage
